<div *ngIf="embeded_url !=''">
    <iframe width="100%" style="min-height: 90vh;" [src]="embeded_url"
        title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
</div>
<body class="style_3" *ngIf="embeded_url ==''">

    <div class="wrapper_centering" style="margin:0">
        <div class="container_centering">
            <div class="container">

                <div class="row justify-content-between">
                    <div class="col-xl-12 ">
                        <div class="main_title_1 text-center">
                                <div *ngIf="this.premsg == 1"> <div class="prescanmsg">
                                    <p innerHTML="{{this.message}}"></p>
                                </div></div>
                                <!-- <div class="content" *ngIf="status == 100">
                                    <div class="master-container">
                                        <ul class="disqualified desktop-app">
                                            <li>
                                                <div class="icon-desktop"> <i class="fa fa-mobile"></i></div>
                                                <h4>
                                                    <div class="checker" id="uniform-undefined"><span [ngClass]="{'checked' : device_type_resp.mobile_study && device_type_resp.mobile_study == 1}"><input type="checkbox"
                                                                class="disabled" checked="" disabled="" style="opacity: 0;"></span></div> Mobile Study
                                                </h4>
                                            </li>
                                            <li>
                                                <div class="icon-desktop"><i class="fa fa-tablet"></i></div>
                                                <h4>
                                                    <div class="checker" id="uniform-undefined"><span [ngClass]="{'checked' : device_type_resp.tablet_study && device_type_resp.tablet_study == 1}"><input type="checkbox"
                                                                class="disabled" checked="" disabled="" style="opacity: 0;"></span></div> Tablet Study
                                                </h4>
                                            </li>
                                            <li>
                                                <div class="icon-desktop"><i class="fa fa-desktop"></i></div>
                                                <h4>
                                                    <div class="checker" id="uniform-undefined"><span><input type="checkbox"  [ngClass]="{'checked' : device_type_resp.desktop_study && device_type_resp.desktop_study == 1}" class="disabled"
                                                                disabled="" style="opacity: 0;"></span></div> Desktop / Laptop Study
                                                </h4>
                                            </li>
                                        </ul>
                                    </div>
                                </div> -->
                                <div *ngIf="this.premsg == 0"> 
                                    <p innerHTML="{{this.message}}"></p>
                                </div>

                                <div *ngIf="this.is_email ==1 && this.is_boat == 0 && this.premsg == 1 ">
                                    <button (click)="submitprescanmessage()" name="process" class="submit">Next</button>  
                                </div>
                            
                            
                            
                            <p style="font-size: 16px;">{{this.otp_message}}</p>
                            <div *ngIf="this.is_boat ==0 && this.is_email ==0 && this.otp_send ==0 && this.message !='' && this.premsg == 1 ">
                                <button (click)="submitmessage()" name="process" class="submit">Next</button>  
                                </div>
                            <div *ngIf="this.is_boat ==1 && this.is_email ==0">
                                <div class="recaptcha"> <ngx-recaptcha2 #captchaElem [siteKey]="siteKey"
                                    [(ngModel)]="captchaResponse">
                                 </ngx-recaptcha2></div>
                               
                             <div *ngIf="this.is_boat ==1  && this.otp_send ==0">
                             <button (click)="submitmessage()" name="process" class="submit">Next</button>  
                             </div>
                            </div>

                            <div *ngIf="this.is_boat ==1 && this.is_email ==1">
                                <div class="recaptcha"> <ngx-recaptcha2 #captchaElem [siteKey]="siteKey"
                                    [(ngModel)]="captchaResponse">
                                 </ngx-recaptcha2></div>
                               
                             <div *ngIf="this.is_boat ==1  && this.otp_send ==0">
                             <button (click)="submitcaptcha()" name="process" class="submit">Next</button>  
                             </div>
                            </div>
                           
                            <div *ngIf="this.is_email ==1 && this.is_boat == 0 && this.premsg == 0 ">
                                <div class="fl-wrap fl-wrap-textarea" *ngIf="this.is_email ==1 && this.otp_send ==0">
                                    <p style="font-size: 16px;">{{this.is_email_message}}</p>
                                    
                                    
                                    <input [(ngModel)]="email"
                                        (cut)="$event.preventDefault()" (copy)="$event.preventDefault()"
                                        (paste)="$event.preventDefault()"
                                        [ngModelOptions]="{standalone: true}"
                                        class="form-control fl-textarea"
                                        placeholder="Enter your email">
                                </div>

                                <div class="fl-wrap fl-wrap-textarea" *ngIf="this.otp_send ==1">
                                    <ng-otp-input  (onInputChange)="numberOnly($event)" [config]="{length:6 , allowNumbersOnly:true, inputClass:'each_input'}"></ng-otp-input>
                                </div>
                                
                             <div *ngIf="this.otp_send == 0 && this.is_email ==1">
                                <button (click)="verifyemail()" name="process" class="submit">Submit</button>  
                             </div>
                             <div *ngIf="this.otp_send == 1">
                                Didn't receive otp?<span *ngIf ="resend"><a (click)="verifyemail()"
                                    style="font-weight:600;cursor: pointer;"> Resend OTP </a></span>
                                    <span *ngIf="resendotp"><a 
                                        style="font-weight:600"> Resend OTP In {{update_sec}} Sec</a></span>
                                <button (click)="verifyotp()" name="process" class="submit">Verify</button>  
                             </div>
                             
                           
                            
                        </div>
                       
                                           
                                           

                          
                        </div>
                    </div>

                    <!-- /col -->
                </div>
            </div>
            <!-- /row -->
        </div>
        <!-- /container_centering -->
    </div>
    <!-- /wrapper_centering -->
</body>
